import stringsIT from './strings-it';
import stringsEN from './strings-en';
import stringsDE from './strings-de';
import stringsES from './strings-es';
import stringsFR from './strings-fr';
import stringsNL from './strings-nl';
import stringsSK from './strings-sk';

import stringsXamarinEN from '@/../xamarin-translations/json/en-US.json';
import stringsXamarinIT from '@/../xamarin-translations/json/it.json';
import stringsXamarinDE from '@/../xamarin-translations/json/de.json';
import stringsXamarinES from '@/../xamarin-translations/json/es.json';
import stringsXamarinFR from '@/../xamarin-translations/json/fr.json';
import stringsXamarinNL from '@/../xamarin-translations/json/nl.json';
import stringsXamarinSK from '@/../xamarin-translations/json/sk.json';

const strings = {
  it: { ...stringsIT, ...stringsXamarinIT },
  en: { ...stringsEN, ...stringsXamarinEN },
  de: { ...stringsDE, ...stringsXamarinDE },
  es: { ...stringsES, ...stringsXamarinES },
  fr: { ...stringsFR, ...stringsXamarinFR },
  nl: { ...stringsNL, ...stringsXamarinNL },
  sk: { ...stringsSK, ...stringsXamarinSK },
};

export default strings;
